module.exports = __webpack_public_path__ + "static/media/facebook.2dc1b175.svg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/facebook.svg
// module id = 1291
// module chunks = 0